import { render } from "./calendar-event-item.vue?vue&type=template&id=9baa492c"
import script from "./calendar-event-item.vue?vue&type=script&lang=js"
export * from "./calendar-event-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__